document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const fromRMA = urlParams.get('fromRMA');
    const message = urlParams.get('message');

    if (fromRMA && message) {
        const messageContainer = document.createElement('div');
        messageContainer.id = 'rma-message';
        messageContainer.style.padding = '10px';
        messageContainer.style.margin = '10px 0';
        messageContainer.style.textAlign = 'center';
        messageContainer.style.borderRadius = '4px';

        if (fromRMA === 'success') {
            messageContainer.style.backgroundColor = '#4CAF50';
            messageContainer.style.color = 'white';
        } else if (fromRMA === 'failed') {
            messageContainer.style.backgroundColor = '#f44336';
            messageContainer.style.color = 'white';
        }

        messageContainer.textContent = decodeURIComponent(message);

        // Insert the message at the top of the main content
        const mainContent = document.querySelector('#main-content');
        if (mainContent) {
            mainContent.insertBefore(messageContainer, mainContent.firstChild);
        }

        // Auto-hide the message after 5 seconds
        setTimeout(() => {
            messageContainer.style.transition = 'opacity 0.5s ease-out';
            messageContainer.style.opacity = '0';
            setTimeout(() => messageContainer.remove(), 500);
            setTimeout(() => {
                const url = new URL(window.location.href);
                url.searchParams.delete('fromRMA');
                url.searchParams.delete('message');
                window.location.href = url.toString();
            }, 500);
        }, 5000);
    }
});